import NavItem from '@/types/NavItem'

export default [
	// Home
	new NavItem({
		icon: 'fa-home',
		title: 'Home',
		view: 'home',
		exact: true,
	}),

	// Studeo
	new NavItem({
		icon: 'fa-database',
		title: 'Studeo',
	})
		.add(new NavItem({
			title: 'Converge Identities',
			permission: 'integration.get',
			view: 'converge-identities',
		}))
		.add(new NavItem({
			title: 'Integrations',
			permission: 'integration.get',
			view: 'integrations',
		}))
		.add(new NavItem({
			title: 'Integrations Logs',
			permission: 'integration.get',
			view: 'integrations-logs',
		}))
		.add(new NavItem({
			title: 'Integrations Status',
			permission: 'integration.get',
			view: 'integrations-status',
		}))
		.add(new NavItem({
			title: 'PriceLabs Status',
			permission: 'integration.get',
			view: 'pricelabs-status',
		}))
		.add(new NavItem({
			title: 'Bookings',
			permission: 'studeo.get',
			view: 'studeo-bookings',
		}))
		.add(new NavItem({
			title: 'Booking Payments',
			permission: 'studeo.get',
			view: 'studeo-booking-payments',
		}))
		.add(new NavItem({
			title: 'Reviews',
			permission: 'studeo.get',
			view: 'studeo-reviews',
		}))
		.add(new NavItem({
			title: 'Website Leads',
			permission: 'studeo.get',
			view: 'studeo-leads',
		}))
		.add(new NavItem({
			title: 'Enterprises',
			permission: 'studeo.get',
			view: 'studeo-enterprises',
		}))
		.add(new NavItem({
			title: 'Resorts',
			permission: 'studeo.get',
			view: 'studeo-resorts',
		}))
		.add(new NavItem({
			title: 'Amenities',
			permission: 'studeo.get',
			view: 'studeo-amenities',
		}))
		.add(new NavItem({
			title: 'Features',
			permission: 'studeo.get',
			view: 'studeo-features',
		})),

	// Reports
	new NavItem({
		icon: 'fa-chart-column',
		title: 'Reports',
	})
		.add(new NavItem({
			title: 'Promo Code Usage Report',
			permission: 'report.get',
			view: 'report-promo-codes',
		}))
		.add(new NavItem({
			title: 'Website Analytics Report',
			permission: 'report.get',
			view: 'report-website-analytics',
		})),

	// Websites
	new NavItem({
		icon: 'fa-globe',
		title: 'Websites',
	})
		.add(new NavItem({
			title: 'Manage Templates',
			permission: 'website.get',
			view: 'website-templates',
		}))
		.add(new NavItem({
			title: 'Manage Websites',
			permission: 'website.get',
			view: 'websites',
		}))
		.add(new NavItem({
			title: 'String Categories',
			permission: 'website.get',
			view: 'string-categories',
		})),

	// Admin
	new NavItem({
		icon: 'fa-key',
		title: 'Admin',
	})
		.add(new NavItem({
			title: 'Users',
			permission: 'uset.get',
			view: 'users',
		}))
		.add(new NavItem({
			title: 'API keys',
			permission: 'api.post',
			view: 'api-keys',
		}))
		.add(new NavItem({
			title: 'API Roles',
			permission: 'role.post',
			view: 'api-roles',
		}))
		.add(new NavItem({
			title: 'Sessions',
			permission: 'session.get',
			view: 'sessions',
		}))
		.add(new NavItem({
			title: 'Notifications',
			permission: 'notification.get',
			view: 'notifications',
		}))
		.add(new NavItem({
			title: 'Feature Flags',
			permission: 'featureflag.get',
			view: 'feature-flags',
		})),

	// System
	new NavItem({
		icon: 'fa-terminal',
		permission: 'system.get',
		title: 'System',
	})
		.add(new NavItem({
			title: 'Status',
			view: 'system-status',
		}))
		.add(new NavItem({
			title: 'Communication Logs',
			permission: 'commlog.get',
			// ff: 'STUD-2753/comm-logs',
			view: 'communication-logs',
		}))
		.add(new NavItem({
			title: 'Events',
			view: 'events',
		}))
		.add(new NavItem({
			title: 'Jobs',
			view: 'jobs',
		}))
		.add(new NavItem({
			title: 'Cron Tab',
			view: 'system-cron',
		}))
		.add(new NavItem({
			title: 'Issues',
			view: 'system-issues',
		}))
		.add(new NavItem({
			title: 'Manual Tests',
			view: 'system-test',
		})),
]
